export enum UsersListSortProp {
	FIRSTNAME = 'firstName',
	LASTNAME = 'lastName',
	USERNAME = 'userName',
	EMAIL = 'email',
	SUBSIDIARYROLE = 'subsidiaryRole',
	USERSTATUS = 'userStatus',
	LASTCONNECTION = 'lastConnection'
}
